<template>
  <span>
    <slot :split="split"></slot>
  </span>
</template>

<script>
  import Mark from 'mark.js';

  const splits = {
    snippet(body) {
      return [{ body }];
    },

    document(body) {
      return body.split(/<hr>/g).map(b => {
        let replaced = b.replace(/^(<p><br><\/p>)*/, '').replace(/(<p><br><\/p>)*$/, '').replace(/(<p><br><\/p>){2,}/, '');

        // kill links
        replaced = replaced.replace(/<a( [^>]+)?>/g, '<span>')
        replaced = replaced.replace(/<\/a>/g, '</span>')

        // kill colors
        replaced = replaced.replace(/[^-]color: ?rgba?\([^(]+\)/g, '')

        // kill color=black
        replaced = replaced.replace(/color: (black|windowtext);?/g, '')

        // kill spaces at beginning of `styles`
        // replaced = replaced.replace(/(?<=style=") /g, '') // safari sucks (at lookbehinds, this time)
        replaced = replaced.replace(/ style=" +/g, ' style="')

        // soften numbers at beginning of lines
        replaced = replaced.replace(/<p([^>]*)>(\(?[0-9\\-]+[A-Z]?[.;)]?)/g, '<p$1><code>$2</code>')

        // convert red
        replaced = replaced.replace(/color: red;?/g, 'font-style: italic;')

        const el = document.createElement('div');
        el.innerHTML = replaced;

        const firstChild = el.children[0];

        const title = firstChild && firstChild.tagName[0].toLowerCase() === 'h' ? firstChild.textContent || firstChild.innerText : null

        let cursor = 0;
        let lastId = 0;

        const ranges = Array.prototype.slice.call(el.children).reduce((memo, child) => {
          if (child.nodeType === 1 && child.tagName.toLowerCase() === 'p') {
            const max = 300;
            const text = child.textContent;
            let split;

            if (text.length) {
              if (text.length < max) {
                split = [text]
              } else {
                const targetLength = Math.round(text.length / Math.ceil(text.length / max));

                const re = new RegExp(`.{1,${targetLength}}(\\s|[.,;!?\\-]+|$)+`, 'g')
                const foo = text.match(re);
                const front = foo.slice(0, -2);
                const back = foo.slice(-2);

                const x = Math.round(back.join('').length / 2);
                const rx = new RegExp(`(^.{1,${x}}(\\s|[.,;!?\\-]+))(.+$)`)
                const match = back.join('').match(rx);

                split = back.length ? front.concat([match[1], match[3]]): front;
              }
            } else {
              split = []
            }

            const segs = split.reduce((acc, string) => {
              const start = cursor

              cursor += string.length
              return acc.concat([{ start, length: string.length, string }])
            }, []);

            const segsLength = segs.length;

            for (let i = segs.length - 2; i >= 0; i--) {
              const tolerance = segs[i + 1].string.match(/^[\s]?([^.,;!?\-\s]+[.,;!?\-\s]+){1,2}/)[0].length;

              segs[i + 1].length -= tolerance
              segs[i + 1].start += tolerance

              segs.splice(i + 1, 0, { start: segs[i].start + segs[i].length, length: tolerance })
            }

            segs.forEach((s, i) => {
              s.ids = i % 2 === 0 ? [lastId + i / 2] : [lastId + Math.floor(i / 2), lastId + Math.floor(i / 2) + 1];
            })

            lastId += segsLength;
            return memo.concat(segs);
          } else {
            cursor += child.textContent.length
            return memo;
          }
        }, []);

        const instance = new Mark(el);
        instance.markRanges(ranges, {
          element: 'span',

          each(element, range) {
            element.classList += `foo ${range.ids.map(id => { return 'foo-' + id }).join(' ')}`
            element.innerHTML = '<span>' + element.innerHTML + '</span>'
          }
        });

        const colorMap = {
          aqua: '0,255,255',
          yellow: '255,255,0',
          lime: '0,255,0'
        }

        el.querySelectorAll('*[style^=background]').forEach(backgrounded => {
          const keys = Object.keys(colorMap);
          const re = new RegExp(`${keys.join('|')}`, 'g');
          const rep = function(key) {
            return `rgb(${colorMap[key]})`;
          }

          backgrounded.style.backgroundColor = backgrounded.style.backgroundColor.replace(re, rep)
        })

        el.querySelectorAll('*[style^=background]').forEach(backgrounded => {
          backgrounded.querySelectorAll('.foo').forEach(foo => {
            foo.style.backgroundColor = backgrounded.style.backgroundColor
          })

          backgrounded.style.backgroundColor = null
        })

        el.querySelectorAll('u').forEach(underlined => {
          underlined.querySelectorAll('.foo').forEach(foo => {
            foo.style.textDecoration = 'underline'
          })

          underlined.style.textDecoration = 'none'
        })

        const segments = ranges.filter(range => { return range.ids.length === 1 })
        let body = el.innerHTML

        // soften highlights
        body = body.replace(/background-color: ?rgba?\((([0-9]+,? ?){3})((0|1).[0-9]+)?\);?/g, 'background-color: rgba($1, 0.5);')

        return { title, body, segments }
      });
    },

    song(body) {
      const p = function(content) {
        return '<p>' + content.replace(/[\s]?\n^[\s]+/gm, ' ').replace(/\n+/g, '</p><p>') + '</p>'
      }

      let split = body.split(/[\n]{2,}/);

      let idx = split.findIndex(section => { return section.match(/^chorus\n/i); })

      if (idx !== -1) {
        let chorus = split[idx].replace(/^chorus\n/i, '');

        let objectified = split.map((body, i) => {
          let verse = i === idx ? false : (i > idx ? i : i + 1);

          return { title: verse ? `Verse ${verse}` : 'Chorus', body: verse ? p(body) : p(chorus) }
        });

        for (let i = split.length; i > idx + 1; i--) {
          objectified.splice(i, 0, { title: 'Chorus', body: p(chorus) })
        }

        return objectified;
      } else {
        return split.map((body, i) => { return { title: `Verse ${i + 1}`, body: p(body) }});
      }
    }
  }

  export default {
    props: ['body', 'preset'],

    computed: {
      split() {
        return splits[this.preset](this.body);
      }
    },

    render() {
      return this.$scopedSlots.default({});
    }
  }
</script>